export const COMPANY = {
  legalName: 'Maaliondoor Services Private Limited',
  brandName: 'Maaliondoor',
  tagline: 'Flowers, Plants & Gifting Solutions',
  address: 'Worxways, H-213, Sector 63, Noida, Uttar Pradesh – 202309, India',
  gstin: '09AANCM9977A1ZV',
  websiteLabel: 'www.maaliondoor.in',
  websiteHref: 'https://www.maaliondoor.in',
  email: 'info@maaliondoor.in',
  emailHref: 'mailto:info@maaliondoor.in',
  phoneDisplay: '+91 99909 26315',
  phoneHref: 'tel:+919990926315',
} as const

export const LEGAL_EFFECTIVE_DATE = '23 July 2026'
